<template>
    <div>
        <h4 class="uk-heading-bullet">
            {{ title }}
        </h4>
        <div uk-margin>
            <button v-for="e in elements" v-bind:key="e" :class="type" class="uk-button uk-button-small uk-margin-right" @click="removeElement(e)">{{ e }}</button>
        </div>
        <hr>
        <div uk-margin>
            <button v-for="m in master" v-bind:key="m" class="uk-button uk-button-default uk-button-small uk-margin-right" @click="addElementFromMaster(m)">{{ m }}</button>
        </div>
        <hr>
        <div class="uk-margin">
            <div class="uk-inline">
                <a class="uk-form-icon uk-form-icon-flip" @click="addElement" uk-icon="icon: tag"></a>
                <input :placeholder="title" v-model="name" class="uk-input uk-width-large" type="text">
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'tags',
    components: {
    },
    props: {
        type: String,
        blockTitle: String,
        blockElements: Array,
        masterElements: Array,
    },
    data: function () {
        return {
            title: this.blockTitle,
            name: '',
            elements: this.blockElements,
            master: this.masterElements,
        }
    },
    methods: {
        addElement: function () {
            if (this.name !== '') {
                if (!this.elements.includes(this.name)) {
                    this.elements.push(this.name)
                    this.name = ''
                    this.sendData()
                } else {
                    this.duplicateElement()
                }
            }
        },
        addElementFromMaster: function (m) {
            if (!this.elements.includes(m)) {
                this.elements.push(m)
                this.sendData()
            } else {
                this.duplicateElement()
            }
        },
        removeElement: function (p) {
            this.elements.splice(this.elements.indexOf(p), 1)
            this.sendData()
            // TODO:
            // this.$emit('set-other-participants', { other_participants: this.o_participants })
        },
        duplicateElement: function () {
            this.$notify({
                title: 'Error',
                message: this.title + ': すでに登録済みです',
                type: 'error'
            });
        },
        sendData: function () {
            this.$emit('setData', {type: this.type, data: this.elements})
        }
    },
    watch: {
        masterElements: function () {
            this.master = this.masterElements
        },
        blockElements: function () {
            this.elements = this.blockElements
        }
    },
    computed: {
    },
    updated: function () {
        this.$nextTick(function () {
            // NOP
        })
    },
    mounted: function () {
        this.$nextTick(function () {
            // NOP
        })
    }
}
</script>

<style>
div h4 {
  margin-top: 40px;
}
div button.uk-button {
  min-width: 80px;
}
button.area {
    background-color: #FFE4A8;
    color: #444;
    border: 1px solid transparent;
}
button.member {
    background-color: #412554;
    color: #fff;
    border: 1px solid transparent;
}
button.tag {
    background-color: #008B52;
    color: #fff;
    border: 1px solid transparent;
}
</style>
